"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Order {
}
exports.default = Order;
//# sourceMappingURL=Order.js.map